module.exports = __webpack_public_path__ + "img/downLoad.019e3f10.jpg";